<template>
    <div>
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    Ordenar productos &nbsp; <small>(seleccione una categoría)</small>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-btn
                        v-for="(cat, i) in categorieList" :key="i"
                        color="primary"
                        class="mx-2 mb-3"
                        @click="openListProducts(cat.id)"
                    >{{ cat.name }}</v-btn>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <!-- dialog -->
        <v-dialog
            v-model="dialogProds"
            width="500"
            scrollable
        >
            <v-card :loading="loading">
                <v-card-title class="text-h5 grey lighten-2">
                    Arrastrar y soltar para ordenar
                </v-card-title>

                <v-card-text>
                    <v-simple-table>
                        <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">
                                    {{ productList.length }} productos
                                </th>
                            </tr>
                        </thead>
                        <draggable
                            :list="productList"
                            :disabled="!enabled"
                            class="list-group"
                            ghost-class="ghost"
                            :move="checkMove"
                            @start="dragging = true"
                            @end="dragging = false"
                            tag="tbody"
                        >
                            <tr v-for="element in productList" :key="element.id" style="cursor: grab;">
                                <td>
                                    <v-list-item class="px-0">
                                        <v-list-item-avatar class="rounded-0" height="60" width="60">
                                            <v-img
                                                :src="element.banner"
                                                aspect-ratio="1.7"
                                                contain
                                            ></v-img>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ element.name }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </td>
                            </tr>
                        </draggable>
                        </template>
                    </v-simple-table>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        text
                        @click="dialogProds = false"
                        :loading="loading"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="upOrderProds"
                        :loading="loading"
                    >
                        Guardar ordenamiento
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
    components: {
        draggable,
    },
    data() {
        return {
            loading: false,
            categorieList: [],
            dialogProds: false,
            productList: [],
            catId: '',
            // drag
            enabled: true,
            list: [
                { name: "John", id: 0 },
                { name: "Joao", id: 1 },
                { name: "Jean", id: 2 }
            ],
            dragging: false
        };
    },
    mounted() {
        this.getCategories()
    },
    methods: {
        async getCategories() {
            await axios.post('/admin/list-categories', {})
            .then(response => {
                // console.log(response);
                this.categorieList = response.data
            })
            .catch(error => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        async openListProducts(cat) {
            this.catId = cat
            this.productList = []
            await axios.post('/admin/prods-by-cat', {cat: cat})
            .then((response) => {
                // console.log(response);
                this.productList = response.data
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
            this.dialogProds = true
        },
        // order
        checkMove: function(e) {
            window.console.log("Future index: " + e.draggedContext.futureIndex);
        },
        async upOrderProds () {
            this.loading = true
            const formData = new FormData()
            for (let index = 0; index < this.productList.length; index++) {
                formData.append(`order[]`, this.productList[index].id)
            }
            formData.append('category', this.catId);
            axios.post(`/admin/update-order-prods`, formData)
            .then(response => {
                console.log(response);
                if (response.data === 'ok') {
                    this.$notify.success("El orden de los productos fue actualizado con éxito.");
                    this.dialogProds = false
                }
                this.loading = false
            })
            .catch(error => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading = false
            })
        }
    },
}
</script>
